import { useIsMobile } from "../context/MobileContext"
import LockIcon from '@mui/icons-material/LockOpen';
import StarsIcon from '@mui/icons-material/Stars';
import parte_5_thumb from '../../images/thumbs/parte_5_thumb.png'


const Bonus:React.FC=()=>{

    const isMobile = useIsMobile()

    return(
        <div style={{width:isMobile?'80vw':'600px', margin:isMobile?'0px auto 5vh':'0 auto',border:'1px solid hsl(46, 100%, 50%)', borderRadius:'5px', display:isMobile?'grid':'', placeItems:'center'}}>
            <div style={{float:isMobile?'none':'left', textAlign:'left', maxWidth:'380px', marginTop:isMobile?'12px':'22px'}}>
                <div style={{marginLeft:'5px'}}>
                    <div style={{float:'left', color:'hsl(46, 100%, 50%)', transform:'translateY(-4px) scale(0.85)', marginRight:'3px'}}><StarsIcon/></div>
                    <div style={{fontFamily:'Digital', color:'hsl(46, 100%, 50%)', fontSize:'15px', float:'left'}}>BONUS</div>
                    <div style={{clear:'both'}}/>
                </div>
                <div style={{fontFamily:'Digital', color:'#ececec', fontSize:'13px', marginLeft:'10px'}}>10 horas de conteudo das primeiras edicoes do Arcalab: Gravando uma banda e Abrindo mixagens</div>
            </div>
                <div style={{float:isMobile?'none':'left', width:isMobile?170*16/9:120*16/9, height:isMobile?'170px':'120px', marginTop:'10px', backgroundImage:`url('${parte_5_thumb}')`, backgroundSize:'cover', borderRadius:'3px', marginBottom:isMobile?'15px':'1vh', transform:isMobile?'none':'translateX(-10px)'}}>
                <div style={{backgroundColor:"rgba(0,0,0,0.2)", height:'100%', width:'100%'}}>
                            <div style={{color:"#fff", position:'relative', top:'50%', transform:'translateY(-50%)'}}>
                                <LockIcon style={{transform:'scale(1.3)'}}/>
                            </div>
                        </div>
                </div>
            {!isMobile&&(<div style={{clear:'both'}}/>)}
        </div>
    )
}

export default Bonus